import { DbRef } from "./firebase";
export const DUMMY_PLACE_GROUP_ID = 'dummyPlaceGroupID';
export var DayOfWeek;
(function (DayOfWeek) {
    DayOfWeek["MONDAY"] = "monday";
    DayOfWeek["TUESDAY"] = "tuesday";
    DayOfWeek["WEDNESDAY"] = "wednesday";
    DayOfWeek["THURSDAY"] = "thursday";
    DayOfWeek["FRIDAY"] = "friday";
    DayOfWeek["SATURDAY"] = "saturday";
    DayOfWeek["SUNDAY"] = "sunday";
})(DayOfWeek || (DayOfWeek = {}));
export const orderedDaysOfWeek = [
    DayOfWeek.MONDAY,
    DayOfWeek.TUESDAY,
    DayOfWeek.WEDNESDAY,
    DayOfWeek.THURSDAY,
    DayOfWeek.FRIDAY,
    DayOfWeek.SATURDAY,
    DayOfWeek.SUNDAY,
];
export var PlaceDisabledReason;
(function (PlaceDisabledReason) {
    /**
     * This lab has been disabled because it is a duplicate of a lab that exists
     * on another place group. It is not desired to show multiples of the same
     * location for scheduling, so the lab will be disabled on one of the place
     * groups. This option allows for future flexibility to implement an admin
     * mode that allows users to force scheduling to the less preferred (disabled)
     * place.
     */
    PlaceDisabledReason["DUPLICATE_ON_OTHER_PLACE_GROUP_PREFERRED"] = "duplicateOnOtherPlaceGroupPreferred";
    /** This place is permanently closed. */
    PlaceDisabledReason["PERMANENTLY_CLOSED"] = "permanentlyClosed";
    /**
     * This lab has been disabled because we are replacing all labs on the place
     * group with those automatically generated by a fulfillment integration.
     */
    PlaceDisabledReason["REPLACED_BY_INTEGRATION"] = "replacedByIntegration";
})(PlaceDisabledReason || (PlaceDisabledReason = {}));
export const PlaceGroupRelationshipKeys = {
    officeID: { ref: DbRef.OFFICES },
    placeGroupTypeID: { ref: DbRef.PLACE_GROUP_TYPES },
    places: { ref: DbRef.PLACES },
};
export var PlaceGroupTypeKind;
(function (PlaceGroupTypeKind) {
    PlaceGroupTypeKind["LAB"] = "lab";
    PlaceGroupTypeKind["FACILITY"] = "facility";
    PlaceGroupTypeKind["STAFFING"] = "staffing";
})(PlaceGroupTypeKind || (PlaceGroupTypeKind = {}));
export const PlaceGroupTypeRelationshipKeys = {
    placeGroups: { ref: DbRef.PLACE_GROUPS },
};
export var ResultsPreference;
(function (ResultsPreference) {
    ResultsPreference["FAX"] = "fax";
    ResultsPreference["PHONE"] = "phone";
})(ResultsPreference || (ResultsPreference = {}));
/**
 * _tags field created on algolia from Place object
 * MANAGES_INVENTORY -> place.placeGroup -> placeGroup.placeGroupType -> placeGroupType.managesInventory
 */
export var AlgoliaPlaceTag;
(function (AlgoliaPlaceTag) {
    AlgoliaPlaceTag["MANAGES_INVENTORY"] = "managesInventory";
})(AlgoliaPlaceTag || (AlgoliaPlaceTag = {}));
export const PlaceRelationshipKeys = {
    placeGroupID: { ref: DbRef.PLACE_GROUPS },
};
//# sourceMappingURL=places.js.map